import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './ProgressBar.scss';

function ProgressBar(props) {
    const {
        className = '',
        loadingBarClassName = '',
    } = props;

    return (
        <div className={classNames(className, styles.container)}>
            <span className={classNames(loadingBarClassName, styles.loadingBar)} />
        </div>
    );
}

ProgressBar.propTypes = {
    className: PropTypes.string,
    loadingBarClassName: PropTypes.string,
};

export default ProgressBar;
